import React, { Component } from 'react';
import {SearchBar, List, Button, Flex, WingBlank, Toast} from 'antd-mobile';
import Mask from '../components/mask'
import _ from 'lodash'
import Bubble from '../components/bubble';
import auth from '../../../utils/auth';
import {FARM_ORG, ORG_CODE} from '../../../cache';
import send from '../../../utils/send';
import send_init from '../../../utils/send_init';
import ListImg from '../../../components/ListImg';
import AutoRefresh from '../../../components/autoRefresh';
import native from '../../../utils/native'

let PAGE = 1;
export default class StaffList extends Component {
  constructor (props) {
    super(props);
    this.state = {
      defaultStaffs: [],//当前登陆用户
      list: [],
      mask: false,
      pageSize: 20,
      tooltips: [
        {
          message: '系统会默认给您提供一个默认的员工，如果您需要添加员工可以点击右上角加号来创建哦！',
          position: {
            top: 190
          },
          visible: true
        }
      ]
    }
  }
  componentDidMount() {
    PAGE=1;
    const _self = this;
    this.debounceData = _.debounce(v=>{
      _self.doSearch(v)
    },500);
    const {isFirst} = this.props.match.params;
    this.setState({
      mask: !!isFirst
    });
    if (isFirst){
      this.getStaffs();
      // 初始化流程
      let farm = auth.readCookie('farm') || {};
      if (farm) {
        this.setState({
          list: [
            {
              realname: farm.farmMan,
              tel_mobile: farm.tel,
              role_names: '养殖场老板,技术员,业务员',
              role_id: '1,36,37',
              ref: 1,
              del_flg: 0
            }
          ]
        })
      }
    }
    else {
      // 列表相关流程
      this.doSearch('')
    }
  }
  doGetNextPageData = () => {
    PAGE++;
    this.doSearch(this.state.name, PAGE)
  };
  doSearch = async (name = '',PAGE = 1) => {
    const {list} = this.state;
    let res = await send({
      url: '/api/ifarm/v180/staff/list',
      method: 'get',
      params: {
        count: this.state.pageSize,
        page: PAGE,
        realname: name,
        code: FARM_ORG,
        parent_code: ORG_CODE
      }
    });
    const resData = res.data;
    const success = resData.statusCode === 200;
    if (success) {
      const data = resData.data;
      this.setState({
        list: PAGE === 1 ? data : [...list, ...data]
      });
    } else {
      Toast.info(resData.message)
    }

  };
  getSaveData = () => {
    const loc = auth.readCookie('loc');
    const farm = auth.readCookie('farm');
    const province = JSON.parse(farm.address[0]);
    const city = JSON.parse(farm.address[1]);
    const town = JSON.parse(farm.address[2]);
    let farrow = loc.loc2Names.map((o, index) => {
      return {
        grp: this.formatNum(index),
        index: index < 10 ? '0' + index: index,
        locationBar: o.num * 1,
        locationName: o.name + '001批'
      }
    });
    let mate = loc.loc1Names.map((o, index) => {
      return {
        grp: this.formatNum(index),
        index: index < 10 ? '0' + index: index,
        locationBar: o.num * 1,
        locationName: o.name + '001批'
      }
    });
    let gilt = loc.loc6Names.map((o, index) => {
      return {
        grp: this.formatNum(index),
        index: index < 10 ? '0' + index: index,
        locationBar: null,
        locationName: o.name + '001批'
      }
    });
    let finishing = [];
    for (var i = 0; i < loc.loc4Names.length; i++) {
      var locName4 = loc.loc4Names[i];
      for (var j = 0; j < locName4.batchNames.length; j++) {
        var batchName4 = locName4.batchNames[j];
        finishing.push({
          grp: this.formatNum(j),
          index: i < 10 ? '0' + (i + 1): i + 1,
          locationBar: null,
          locationName: locName4.name + batchName4.name + '批'
        })
      }
    }
    let nursery = [];
    for (var a = 0; a < loc.loc3Names.length; a++) {
      var locName3 = loc.loc3Names[a];
      for (var b = 0; b < locName3.batchNames.length; b++) {
        var batchName3 = locName3.batchNames[b];
        nursery.push({
          grp: this.formatNum(b),
          index: a < 10 ? '0' + (a + 1): a + 1,
          locationBar: null,
          locationName: locName3.name + batchName3.name + '批'
        })
      }
    }
    return {
      loc,
      farm,
      province,
      city,
      town,
      farrow,
      finishing,
      mate,
      gilt,
      nursery
    }
  };
  saveData = async () => {
    Toast.loading('请稍等', 8);
    const {
      finishing,
      farm,
      province,
      city,
      town,
      farrow,
      mate,
      gilt,
      nursery} = this.getSaveData();

    let step1 = await send_init({
      url: '/api/forward/ifarm/simpleStep/saveStep1',
      method:'post',
      data:{
        cityCode: city.code,
        cityName: city.name,
        farmCapacity: farm.farmScale,
        farmLocaion: `${province.name},${city.name},${town.name}`,
        farmLocaionCode: `${town.code}`,
        farmManager: farm.farmMan,
        farmManagerContact: farm.tel,
        farmName: farm.farmName,
        farmType: farm.farmType,
        latitude: window.lat,
        longitude: window.lng,
        method: 'ADD',
        provinceCode: province.code,
        provinceName: province.name,
        farmHouseReq: {
          farrow,
          finishing,
          gilt,
          mate,
          nursery
        }
      }
    });
    console.log('step1: 场信息储存');
    if (step1.data.statusCode !== '200') {
      Toast.info(step1.data.msg);
      return
    }
    let step2 = await send_init({
      url: '/api/ifarm/v180/staff/batch_staff',
      method:'post',
      data: {
        method: 'add',
        staffs: this.state.defaultStaffs
      }
    });
    console.log('step2: 检查用户信息是否重复。');

    if (step2.data.statusCode !== 200) {
      Toast.info(step2.data.message);
      return
    } else if (step2.data.message) {
      Toast.info(step2.data.message,3);
    }
    auth.setCookie('createdStaffs',step2.data.data);
    let step3 = await send_init({
      url: '/api/forward/ifarm/simpleStep/saveStep2',
      data:{
        cityCode: city.code,
        cityName: city.name,
        farmCapacity: farm.farmScale,
        farmLocaion: `${province.name},${city.name},${town.name}`,
        farmLocaionCode: `${town.code}`,
        farmManager: farm.farmMan,
        farmManagerContact: farm.tel,
        farmName: farm.farmName,
        farmType: farm.farmType,
        latitude: window.lat,
        longitude: window.lng,
        method: 'ADD',
        provinceCode: province.code,
        provinceName: province.name
      },
      method:'POST'
      });
    console.log('step3:  保存3。');

    if (Number(step3.data.statusCode) !== 200 ) {
      Toast.info(step3.data.msg);
    } else {
      this.jumpToProduct()
    }
  };
  saveData0 = () => {
    this.jumpToProduct()
  };
  jumpToProduct = () => {
    Toast.loading('请稍等', 0.5, () => {
      this.props.history.replace({
        pathname: '/createfarm/product_add'
      });
      auth.setCookie('path','/createfarm/product_add')
    })

  };
  getFarmStaff = async () => {
    // 默认创建农场时候的为一个员工
    const farm = auth.readCookie('farm');
    let resNewStaff = await send_init({
      url: '/api/ifarm/v180/staff/staff',
      method: 'get',
      params: {
        tel_mobile: farm.tel,
        code: auth.readCookie('FARMORG') + '-0-0',
        parent_code: auth.readCookie('ORGCODE')
      }
    });
    //是否是新员工
    let newStaff = !resNewStaff.data.data;
    let id = newStaff? '': resNewStaff.data.data.id;
    return {
      username: farm.farmMan,
      phoneNum: farm.tel,
      type: [
        {
          label: '养殖场老板',
          value: '1',
          checked: true
        },
        {
          label: '技术员',
          value: '37',
          checked: true
        },
        {
          label: '业务员',
          value: '36',
          checked: true
        }
      ],
      contact: true,
      id,
      newStaff:newStaff
    }
  };
  getStaffs = async () => {
    Toast.loading('请稍等', 1);
    let staffs = [];
    let staff1 = await this.getFarmStaff(); // 创建农场的人
    let staff2 = auth.readCookie('userInfo') || {}; // 登陆用户
    if (Object.keys(staff2).length === 0) {
      auth.getUserInfo().then(res => {
        const {data, code, msg} = res;
        if (code === 200) {
          staff2 = data
        } else {
          // 没有获取到用户信息，无法继续下一步
          Toast.info(msg, 2, () => {
            native.callNativeModal('backHome')
          })
        }
      })
    }
    if (staff1.phoneNum === staff2.phoneNum) {
      // 当两个电话一样，就默认农场填的。
      staffs.push(staff1)
    } else {
      staffs.push(staff1,staff2)
    }
    this.setState({
      defaultStaffs: staffs
    })
  };
  formatNum = (index) => {
    let str = '';
    if (index < 9) {
      str = '00' + (index + 1)
    } else if (index < 99) {
      str = '0' + (index + 1)
    } else {
      str = index + 1
    }
    return str
  };
  render() {
    const {list, mask} = this.state;
  return (
    <React.Fragment>
      <SearchBar placeholder={'点击搜索员工名称'}
          onChange={v => {
                   PAGE=1;
                   this.setState({name: v});
                   this.debounceData(v)
                 }}
      />
        <AutoRefresh
            damping={60}
            direction={'up'}
            indicator={{ deactivate: '上拉可以刷新' }}
            onRefresh={() => {
              this.doGetNextPageData()
            }}
            refreshing={this.state.refreshing}
            style={{
            height: window.HEIGHT - 44,
            overflowY: 'auto'
          }}
            top={44}
            size={this.state.list.length}
            total={this.state.list.length}
        >
          <WingBlank size={'md'}>
            {list.length === 0 ? <ListImg/>: null}

            {
              list.map(((o,index) => {
                return <List
                    className={(this.state.mask && index === 0)? 'topShow w-10 round-list': 'round-list'}
                    key={'staffList' + index}
                       >
                  <List.Item
                      extra={<span className={o.ref === 1 ? 'active-text': 'text-2'}>{o.ref === 1 ? '已引入': '未引入'}</span>}
                  >
                    <span className={'text-3'}>{o.realname}</span>
                  </List.Item>
                  <List.Item className={'no-border span-4'}
                      extra={<b>{o.role_names}</b>}
                  >
                    猪场岗位:
                  </List.Item>
                  <List.Item className={'no-border'}
                      extra={<b>{o.tel_mobile}</b>}
                  >
                    联系方式:
                  </List.Item>
                </List>
              }))
            }
          </WingBlank>

        </AutoRefresh>

      <Mask visible={mask}>
        {
          this.state.tooltips.map((item, index) => {
            return <Bubble
                key={index}
                visible={'true'}
                {...item.position}
                   >
              <div className={'line'}
                  style={{
                     transform: 'rotate(180deg)'
                   }}
              />
              {item.message}
              <Flex justify={'between'}
                  style={{marginTop: 20}}
              >
                <div  style={{width: 120}}>
                  <Button
                      onClick={() => {
                        this.saveData()
                      }}
                  >使用默认</Button>
                </div>
                <div  style={{width: 120}}>
                  <Button
                      type={'primary'}
                      onClick={() => {
                              this.props.history.replace('/createfarm/staff_add');
                              auth.setCookie('path','/createfarm/staff_add')
                          }}
                  >创建员工</Button>
                </div>

              </Flex>
            </Bubble>
          })
        }
      </Mask>
    </React.Fragment>
  )
 }
}
